import { heroStats, latestUpdates } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section className="relative w-full overflow-hidden bg-foreground-950">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20amber%20and%20deep%20charcoal%20textured%20background%20with%20soft%20paper%20grain%20and%20layered%20collage%20feel%2C%20muted%20burnt%20orange%20gradients%20and%20thin%20light%20streaks%2C%20cinematic%20editorial%20mood%20for%20a%20community%20discussion%20landing%20section%2C%20minimal%20composition%20with%20clear%20negative%20space%20for%20large%20text&width=1600&height=900&seq=hei17-shell-hero-01&orientation=landscape"
        alt="17黑料网首页视觉背景"
        title="17黑料网 避雷名单 人品盘点"
        className="absolute inset-0 h-full w-full object-cover object-top opacity-70"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/55 to-foreground-950/80" />

      <div className="relative mx-auto w-full max-w-[1280px] px-4 py-14 md:px-6 md:py-20 lg:py-24">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1.15fr_0.85fr] lg:gap-14">
          <div className="animate-fade-up">
            <span className="inline-flex items-center gap-2 rounded-full border border-background-50/25 px-3 py-1.5 font-label text-[12px] tracking-[0.16em] text-background-200">
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-shield-star-line text-sm text-accent-300" />
              </span>
              路人视角 · 公众人物避雷参考
            </span>

            <h2 className="mt-6 font-heading text-[34px] font-black leading-[1.18] tracking-tight text-background-50 sm:text-[44px] lg:text-[54px]">
              谁不值得追，
              <br className="hidden sm:block" />
              先看这份
              <span className="mx-2 inline-block -rotate-1 rounded-md bg-accent-500 px-2 text-foreground-950">
                避雷名单
              </span>
            </h2>

            <p className="mt-6 max-w-xl text-sm leading-[1.9] text-background-200 md:text-[15px]">
              17黑料网把散落在讨论区的人品盘点、脱粉原因与粉丝回踩说法，整理成可检索的档案。
              这里不替你审判，只把公开讨论摆清楚，让你在投入时间和钱之前，多一个判断的参照。
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#blacklist"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 font-label text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-list-check-2 text-base" />
                </span>
                查看避雷名单
              </a>
              <a
                href="#topics"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 font-label text-sm text-background-100 transition-colors duration-200 hover:bg-background-50/10"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-price-tag-3-line text-base" />
                </span>
                浏览话题墙
              </a>
            </div>

            <dl className="mt-10 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-50/15 pt-7 sm:grid-cols-4">
              {heroStats.map((item) => (
                <div key={item.label}>
                  <dt className="font-label text-[12px] text-background-300">{item.label}</dt>
                  <dd className="mt-1 font-heading text-2xl font-bold text-accent-300">
                    {item.value}
                  </dd>
                </div>
              ))}
            </dl>
          </div>

          <aside className="animate-fade-up rounded-lg border border-background-50/15 bg-background-50/8 p-4 backdrop-blur-sm md:p-5">
            <div className="flex items-center justify-between border-b border-background-50/15 pb-3">
              <span className="font-label text-[13px] font-medium text-background-100">
                更新条 · 今日动态
              </span>
              <span className="flex items-center gap-1.5 font-label text-[11px] text-primary-300">
                <span className="animate-live-dot block h-1.5 w-1.5 rounded-full bg-primary-400" />
                滚动中
              </span>
            </div>
            <ul className="mt-2 max-h-[340px] divide-y divide-background-50/10 overflow-y-auto">
              {latestUpdates.map((item, index) => (
                <li key={item.time} className="flex gap-3 py-3">
                  <span className="mt-0.5 shrink-0 font-label text-[12px] tabular-nums text-background-400">
                    {item.time}
                  </span>
                  <p
                    className={
                      index === 0
                        ? 'text-[13px] leading-relaxed text-background-50'
                        : 'text-[13px] leading-relaxed text-background-300'
                    }
                  >
                    {item.text}
                  </p>
                </li>
              ))}
            </ul>
            <a
              href="#unfollow"
              className="mt-3 flex items-center justify-center gap-2 rounded-md border border-background-50/20 py-2.5 font-label text-[13px] text-background-100 transition-colors duration-200 hover:bg-background-50/10"
            >
              进入讨论区
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-arrow-right-line text-base" />
              </span>
            </a>
          </aside>
        </div>
      </div>
    </section>
  );
}